import React from "react";
import cn from "classnames";
import { LABEL } from "../../../veriables";
import { getObjectValue, urlSearchParams } from "../../../utility/utills";

export const Subtotal = React.forwardRef(({ tableData, countryCode, serverAppTheme, currenySymbol, serviceChargeAmount, currentTipValue, tipAmount, discountAmount, deviceInfo, isLandScape, ...props }, ref) => {

    const seatData = JSON.parse(window.sessionStorage.getItem('seat'));
    const isShowOffers = seatData?.paymentCheck?.offer?.saved === true;

    const renderRoundingAmount = () => {
        const cashTicket = props.seat?.paymentCheck?.tickets?.find(e => e.id === tableData?.paymentCheck?.cashTicketId);
        if (countryCode !== '44' && cashTicket?.paymentTypeName === "Cash" && !!cashTicket?.cashRoundingAmount) {
            const roundingAmt = cashTicket?.cashRoundingAmount ?? 0;
            return (
                <div className="row mx-0">
                    <div className={cn('col-6 p-0 text-left')}>{LABEL().RECEIPT_ROUNDING}</div>
                    <div className={cn('p-0 text-right col-6')}>
                        {(roundingAmt ?? 0) < 0
                          ? `-${currenySymbol}${Math.abs(roundingAmt ?? 0).toFixed(2)}`
                          : `${currenySymbol}${(roundingAmt ?? 0).toFixed(2)}`
                        }
                        {/* {currenySymbol}{Math.abs(Number(roundingAmt)).toFixed(2)} */}
                    </div>
                </div>
            );
        }
        return null;
    };
    return (
        <div ref={ref} className={cn("col-12 p-2 rounded")} style={{ backgroundColor: props.detailSection && serverAppTheme?.checkDetail_tabs }}>
            {tableData?.items && tableData?.items?.length > 0 && (
                <div
                    className={cn(`col-12 mx-0 px-0`)}
                    style={{
                        color: serverAppTheme?.primary_text,
                    }}
                >
                    <div className={cn("col-12 px-0 fs_16 fw-400")}>
                        <div
                            className={cn("col-12 px-0")}
                            style={{
                                overflow:
                                    document.querySelectorAll("#innerDiv").length > 5 && "scroll",
                            }}
                        >
                            {countryCode !== '44' && ((tableData?.discounts?.length > 0 || props.seat?.paymentCheck?.discounts.length > 0) || props.seat?.paymentCheck?.offer != null) && (
                                <div className={cn("row m-0")}>
                                    <div className="col-6 p-0 text-left">{LABEL().RECEIPT_ITEMS}</div>
                                    <div className="col-6 p-0 text-right">
                                        {currenySymbol}{(tableData.itemAmount || tableData.itemAmount === 0) && tableData?.itemAmount?.toFixed(2)}
                                    </div>
                                </div>
                            )}
                            {/* Discount */}
                            {tableData?.discountAmount > 0 && !props?.seat?.paymentCheck?.offer && (
                                <div className="row mx-0">
                                    <div className={cn("col-6 p-0 text-left")}>{LABEL().RECEIPT_DISCOUNT}</div>
                                    <div className={cn("col-6 p-0 text-right")}>
                                        -{currenySymbol}{Number(tableData?.discountAmount).toFixed(2)}
                                    </div>
                                </div>
                            )}
                            {/* {props.seat?.paymentCheck?.offers[0]?.saved && (
                                <div className="row mx-0">
                                    <div className="col-6 p-0 text-left">{LABEL().RECEIPT_DISCOUNT}</div>
                                    <div className={cn('col-6 p-0 text-right' )}>
                                         -{currenySymbol}{props?.seat?.paymentCheck?.offers[0]?.value?.toFixed(2)}
                                    </div>
                                </div>
                            )} */}
                            {countryCode !== '44' && (
                                <div
                                    className="row mx-0 fw-normal h-auto w-100 fs_16 fw-400"
                                    id="innerDiv"
                                >
                                    {['22'].includes(urlSearchParams('screenType')) && (props?.seat?.paymentCheck?.offer?.isCoupon ||
                                        props?.seat?.paymentCheck?.offer) && (
                                            <>
                                                {(isShowOffers && !props?.seat?.paymentCheck?.offer?.isCoupon) ? (
                                                    <div className={cn('col-8 p-0 text-left')}>
                                                        {LABEL().DISCOUNT_AMOUNT}
                                                    </div>
                                                ) : (
                                                    <div className={cn('col-8 p-0 text-left')}>
                                                        {props?.seat?.paymentCheck?.offer?.isCoupon
                                                            ? LABEL().RECEIPT_COUPON_KEY
                                                            : LABEL().RECEIPT_OFFER_KEY}{' '}
                                                        (
                                                        {props?.seat?.paymentCheck?.offer?.name
                                                            ?.length > 12
                                                            ? `${props.seat.paymentCheck.offer.name.slice(
                                                                0,
                                                                12
                                                            )}...`
                                                            : props.seat.paymentCheck.offer.name}
                                                        )
                                                    </div>
                                                )}
                                                <div
                                                    className={cn(
                                                        'col-4 p-0 text-right fw-normal fs_16 fw-400'
                                                    )}
                                                >
                                                    -{currenySymbol}
                                                    {!props?.seat?.paymentCheck?.offer?.isCoupon ? props?.seat?.paymentCheck?.discountAmount?.toFixed(2) : props?.seat?.paymentCheck?.offer?.value?.toFixed(2)}
                                                </div>
                                            </>
                                        )}
                                </div>
                            )}

                            {countryCode !== '44' && (
                                <div className="row mx-0">
                                    <div className={cn('col-6 p-0 text-left')}>{LABEL().RECEIPT_SUBTOTAL}</div>
                                    <div className={cn('p-0 text-right col-6')}>
                                        {currenySymbol}
                                        {(props.seat?.paymentCheck?.subTotalAmount || props.seat?.paymentCheck?.subTotalAmount === 0)
                                            ? props.seat?.paymentCheck?.subTotalAmount?.toFixed(2)
                                            : (deviceInfo?.deviceGroup?.startMode === 1 || deviceInfo?.deviceGroup?.startMode === 2)
                                                ? ((tableData.subTotalAmount || tableData.subTotalAmount === 0)
                                                    ? tableData?.subTotalAmount?.toFixed(2)
                                                    : '0.00')
                                                : ((props.seat?.subTotalAmount || props.seat?.subTotalAmount === 0)
                                                    ? props.seat?.subTotalAmount?.toFixed(2)
                                                    : '0.00')
                                        }
                                    </div>
                                </div>
                            )}
                            {(countryCode === '44' && ((props.seat?.paymentCheck instanceof Object) ? props.seat?.paymentCheck?.totalAmount >= 0 : tableData?.totalAmount >= 0)) &&
                                <div className="row mx-0">
                                    <div className={cn('col-6 p-0 text-left')}>{LABEL().RECEIPT_TOTAL}</div>
                                    <div className={cn('p-0 text-right col-6')}>
                                        {currenySymbol}
                                        {(props.seat?.paymentCheck?.totalAmount || props.seat?.paymentCheck?.totalAmount === 0)
                                            ? props.seat?.paymentCheck?.totalAmount?.toFixed(2)
                                            : (tableData?.totalAmount || tableData?.totalAmount === 0) && tableData?.totalAmount?.toFixed(2)
                                        }
                                    </div>
                                </div>
                            }
                            {(countryCode !== '44' && (props.seat?.paymentCheck instanceof Object) ? props.seat?.paymentCheck?.taxAmount >= 0 : tableData?.taxAmount >= 0) && (
                                <div className="row mx-0">
                                    <div className={cn('col-6 p-0 text-left')}>{LABEL().RECEIPT_TAX}</div>
                                    <div className={cn('p-0 text-right col-6')}>
                                        {currenySymbol}
                                        {(props.seat?.paymentCheck instanceof Object)
                                            ? ((props.seat?.paymentCheck?.taxAmount || props.seat?.paymentCheck?.taxAmount === 0) && props.seat?.paymentCheck?.taxAmount?.toFixed(2))
                                            : ((tableData?.taxAmount || tableData?.taxAmount === 0) && tableData?.taxAmount?.toFixed(2))
                                        }
                                    </div>
                                </div>
                            )}
                            {serviceChargeAmount > 0 && (
                                <div className="row mx-0">
                                    <div className="col-6 p-0 text-left">{LABEL().RECEIPT_SERVICE_CHARGE}</div>
                                    <div className={cn('col-6 p-0 text-right' )}>
                                        {currenySymbol}{serviceChargeAmount?.toFixed(2)}
                                    </div>
                                </div>
                            )}
                            {(countryCode !== '44' && ((props.seat?.paymentCheck instanceof Object) ? props.seat?.paymentCheck?.totalAmount >= 0 : tableData?.totalAmount >= 0)) &&
                                <div className="row mx-0">
                                    <div className={cn('col-6 p-0 text-left')}>{LABEL().RECEIPT_TOTAL}</div>
                                    <div className={cn('p-0 text-right col-6')}>
                                        {currenySymbol}
                                        {(props.seat?.paymentCheck?.totalAmount || props.seat?.paymentCheck?.totalAmount === 0)
                                            ? props.seat?.paymentCheck?.totalAmount?.toFixed(2)
                                            : (tableData?.totalAmount || tableData?.totalAmount === 0) && tableData?.totalAmount?.toFixed(2)
                                        }
                                    </div>
                                </div>
                            }

                            {(currentTipValue || tableData?.paymentCheck?.tip?.tipAmount > 0 || tableData?.tipAmount > 0) && (
                                <div className="row mx-0">
                                    <div className={cn('col-6 p-0 text-left' )}>{LABEL().RECEIPT_TIP} </div>
                                    <div className={cn('p-0 text-right col-6')}>
                                        {currenySymbol}{currentTipValue || ((tableData?.paymentCheck?.tip?.tipAmount ?? 0)?.toFixed(2)) || ((tableData?.tipAmount ?? 0)?.toFixed(2)) || '0.00'}
                                    </div>
                                </div>
                            )}
                            {renderRoundingAmount()}
                            {(props.seat?.paymentCheck?.totalCollectedAmount > 0) &&
                                <div className="row mx-0">
                                    <div className={cn('col-6 p-0 text-left')}>{LABEL().RECEIPT_PAID}</div>
                                    <div className={cn('p-0 text-right col-6')}>
                                        {currenySymbol}{props.seat?.paymentCheck?.totalCollectedAmount?.toFixed(2)}
                                    </div>
                                </div>
                            }
                            {countryCode !== '44' && props.seat?.paymentCheck?.giftCard &&
                                <div className="row mx-0">
                                    <div className={cn('col-8 p-0 text-left')}>{LABEL().RECEIPT_GIFT_CARD} {props.seat?.paymentCheck?.giftCard?.displayAccountNumber}</div>
                                    <div className={cn('p-0 text-right col-6')}>
                                        {currenySymbol}{props?.seat?.paymentCheck?.giftCard?.paymentAmount?.toFixed(2)}
                                    </div>
                                </div>}

                            {countryCode !== '44' && !props.seat?.paidAmount == 0 && (
                                <div className="row mx-0 align-items-center fw-700">
                                    <div className={cn('col-6 p-0 text-left')}>{LABEL().RECEIPT_DUE}</div>
                                    <div className={cn('col-6 p-0 text-right' )}>
                                        {currenySymbol}{props.seat?.paymentCheck?.paymentAmount >= 0 ? Number(props.seat?.paymentCheck?.paymentAmount)?.toFixed(2) : Number(tableData.unpaidAmount)?.toFixed(2)}
                                    </div>
                                </div>
                            )}

                            {getObjectValue(() => paidTips > 0, false) && (
                                <div className="row m-0">
                                    <div className="col-6 p-0 text-left">{LABEL().RECEIPT_PAID_TIPS} </div>
                                    <div className={cn('col-6 p-0 text-right')}>
                                        {currenySymbol}{Number(paidTips).toFixed(2)}
                                    </div>
                                </div>
                            )}
                            {getObjectValue(() => unpaidTips > 0, false) && (
                                <div className="row m-0">
                                    <div className="col-6 p-0 text-left">{LABEL().RECEIPT_UNPAID_TIP} </div>
                                    <div className={cn('col-6 p-0 text-right' )}>
                                        {currenySymbol}{Number(unpaidTips)?.toFixed(2)}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
});
